import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function LabsListPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 p-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Labs Management</h1>
        <Button
          className="bg-blue-600 hover:bg-blue-700"
          onClick={() => navigate("/super-admin/labs/create")}
        >
          + Add Lab
        </Button>
      </div>

      {/* Labs List */}
      <Card>
        <CardHeader>
          <CardTitle>All Labs</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-center text-gray-500 py-8">
            No labs found. Click "Add Lab" to create one.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
